import GoToDashboard from "../components/screens/GoToDashboard";

function Home() {
    return (<GoToDashboard />)
}

export default Home;